/**
 * @desc 费用中心--费用概览/账单明细
 * @author 赵轮
 * @date 2023年10月23日20:22:12
 */
export default {
  火山语音费用: '火山语音费用',
  费用概览: '费用概览',
  账单明细: '账单明细',
  火山通话记录: '火山通话记录',
  火山号码月租: '火山号码月租',
  按明细: '按明细',
  按日: '按日',
  按月: '按月',
  请选择人员: '请选择人员',
  时间: '时间',
  通话量: '通话量',
  通话总费用: '通话总费用',
  主叫通话时长: '主叫通话时长',
  主叫计费时长: '主叫计费时长',
  主叫通话费用: '主叫通话费用',
  主叫号码: '主叫号码',
  主叫号码归属地: '主叫号码归属地',
  主叫侧外显号码: '主叫侧外显号码',
  主叫外显号码池编号: '主叫外显号码池编号',
  主叫外显号码池名称: '主叫外显号码池名称',
  被叫号码: '被叫号码',
  被叫计费时长: '被叫计费时长',
  被叫通话费用: '被叫通话费用',
  被叫号码归属地: '被叫号码归属地',
  被叫侧外显号码: '被叫侧外显号码',
  被叫外显号码池编号: '被叫外显号码池编号',
  被叫外显号码池名称: '被叫外显号码池名称',
  呼叫方向: '呼叫方向',
  通话状态: '通话状态',
  通话员工: '通话员工',
  '火山-语音服务余额': '火山-语音服务余额',
  '天眼查套餐（剩余次数/总次数）': '天眼查套餐（剩余次数/总次数）',
  到期时间: '到期时间',
  数据更新时间: '数据更新时间',
  流水明细: '流水明细',
  消费: '消费',
  充值: '充值',
  '火山-语音服务': '火山-语音服务',
  '天眼查-按次计费': '天眼查-按次计费',
  '天眼查-按套餐计费': '天眼查-按套餐计费',
  请选择流水类型: '请选择流水类型',
  请选择业务类型: '请选择业务类型',
  流水类型: '流水类型',
  业务类型: '业务类型',
  '变动金额（火山-语音服务）': '变动金额（火山-语音服务）',
  '变动后余额（火山-语音服务）': '变动后余额（火山-语音服务）',
  '变动套餐次数（天眼查）': '变动套餐次数（天眼查）',
  '套餐剩余次数（天眼查）': '套餐剩余次数（天眼查）',
  扣款时间: '扣款时间',
  费用: '费用',
  扣款内容: '扣款内容',
  号码: '号码',
  号码类型: '号码类型',
  归属地: '归属地',
  号码池编号: '号码池编号',
  号码池名称: '号码池名称',
  购买时间: '购买时间'
};
